import "./App.scss";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home.jsx";
import { FloatingWhatsApp } from "react-floating-whatsapp";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
      <a
        target="_blank"
        href="https://api.whatsapp.com/send/?phone=+6281316708803&text=Halo%20Wisnu,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Rumah%20https://marketing-bukitpodomorojakarta.com/&type=phone_number&app_absent=0"
      >
        <FloatingWhatsApp />
      </a>
    </Router>
  );
}

export default App;
